import React, { PropsWithChildren, useState } from 'react'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { FormValues } from '../../../../../utils/type'
import { Me } from '../../../../../service/user'
import { CircularCheckbox } from 'components/CircularCheckbox'
import { PreviewTag } from 'components/tag/PreviewTag'
import { PurchaseInfoGuideTooltip } from '../PurchaseInfoGuideTooltip'
import useTranslation from '../../../../../hooks/useTranslation'

interface PurchaseGuideDisplayProps {
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
  userInfo: Me
}
export const PurchaseGuideDisplay = ({
  watch,
  setValue,
  control,
  userInfo,
}: PropsWithChildren<PurchaseGuideDisplayProps>) => {
  const { t } = useTranslation()
  const [isOpenPurchaseInfoGuideModal, setIsOpenPurchaseInfoGuideModal] =
    useState<boolean>(false)
  return (
    <div className="price  my-[40px]">
      <div className="flex flex-col md:mb-[16px] gap-4 ">
        <p className="font-bold text-[18px] flex items-center gap-3 relative">
          {t('productVideoEditor.testEffect.purchaseGuide')}{' '}
          <PreviewTag setIsOpenModal={setIsOpenPurchaseInfoGuideModal} />
          {isOpenPurchaseInfoGuideModal && (
            <PurchaseInfoGuideTooltip
              setIsOpenPurchaseInfoGuideModal={setIsOpenPurchaseInfoGuideModal}
            />
          )}
        </p>
        <div className="grid grid-cols-2 ">
          {[
            { name: t('productVideoEditor.testEffect.include'), value: 1 },
            { name: t('productVideoEditor.testEffect.exclude'), value: 0 },
          ].map((el, index) => {
            return (
              <div key={index}>
                <label
                  onClick={() => {
                    setValue(`products.0.purchaseInfoFlag`, el.value)
                  }}
                >
                  <Controller
                    render={({ field }) => (
                      <CircularCheckbox
                        {...field}
                        id={index}
                        checked={
                          watch(`products.0.purchaseInfoFlag`) === el.value
                        }
                        label={el.name}
                        onChange={() => {}}
                        disabled={
                          !userInfo || userInfo?.userType === 'normalUser'
                        }
                      />
                    )}
                    name={`products.0.purchaseInfoFlag`}
                    control={control}
                  />
                </label>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
